// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var InvoiceDetailsController = function ($scope, $routeParams, Invoice, InvoiceDownload) {
    $scope.invoiceDetails = Invoice.get({ id: $routeParams.invoiceId });

    $scope.download = function (id) {
        var downloadInfo = new InvoiceDownload();
        downloadInfo.$save({ id: $routeParams.invoiceId }, function () {
            window.location = downloadInfo.Url;
        });
    };
}
InvoiceDetailsController.$inject = ['$scope', '$routeParams', 'Invoice', 'InvoiceDownload'];
